module.exports = __webpack_public_path__ + "static/media/folder.e4f760de.svg";